import { AlertCircleIcon, CheckCircleIcon } from '@/components/ui/icons'
import { Spinner } from '@/components/ui/spinner'
import { cn } from '@/helpers/utils'

interface InputStatusIconProps {
	hasError?: boolean
	touched?: boolean
	isLoading?: boolean
}

export const InputStatusIcon = ({
	hasError,
	touched,
	isLoading
}: InputStatusIconProps) => {
	return (
		<div
			className={cn(
				'absolute top-1/2 right-2 h-4 -translate-y-1/2',
				hasError ? 'text-danger-300' : 'text-success-300'
			)}
		>
			{isLoading && <Spinner className='fill-neutral-600' size={16} />}
			{hasError && !isLoading && <AlertCircleIcon data-color size={16} />}
			{touched && !hasError && !isLoading && (
				<CheckCircleIcon data-color size={16} />
			)}
		</div>
	)
}

InputStatusIcon.displayName = 'InputStatusIcon'
